import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import CardUser from "./CardUser";
import PermisosUser from "./PermisosUser";
const Usuarios = ({ user }) => {

  return (
    <DivRow>
      <>
        <Text3
          style={{
            fontSize: "25px",
            fontWeight: "bold"
          }}
        >
          Usuarios
        </Text3>
        <DivColumPlanillas>
          <Text3
            style={{
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "18px",
              letterSpacing: "2%"
            }}
          >
            EDITAR PERMISOS DE USUARIOS
          </Text3>

          <ScrollContainer >
            <CardUser />
            <CardUser />
            <CardUser />
            <CardUser />
            <CardUser />
            <CardUser />
            <CardUser />
            <CardUser />
          </ScrollContainer>
        </DivColumPlanillas>
      </>
      <PermisosUser/>
    </DivRow>

  );
};

const DivColumPlanillas = styled.div`
width: calc(45% - 50px);
display:flex;
flex-direction: column;
gap:1px;
flex-grow: 1;
margin-top:8px;
`;

const DivRow = styled.div`
width: 80%;
padding: 46px;
display: flex;
flex-wrap: wrap;
align-items: flex-start;
justify-content: flex-start;
box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
border-radius: 8px;
flex-direction: row;
`;

const Text3 = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
color: #003049;
`;

const ScrollContainer = styled.div`
width: -webkit-fill-available;
height: auto;
max-height: 250px;
overflow-y: auto;
overflow-x: hidden;
gap: 0px;
display: flex;
flex-direction: column;
align-items: flex-start;
margin: 0%;
scroll-behavior: smooth;
padding: 8px 0px 0px 0px;
justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;

export default Usuarios;